// extracted by mini-css-extract-plugin
module.exports = {"phonePrefixItem":"PhonePrefixItem_phonePrefixItem__Ngb53","cofDesignV1":"PhonePrefixItem_cofDesignV1__dxZi_"};